import * as React from 'preact'
import styles from '../../../css/auth.pcss.json'
import SVG from '../SVG'

interface PropTypes {
  goBack: () => void,
  text?: string
}

const BackButton = ({ goBack, text }: PropTypes): React.VNode =>
  <button className={styles['auth-back-button']} onClick={goBack}>
    <SVG i='sg/chevron-left'/> {text ?? 'Назад'}
  </button>

export default BackButton
